const dummy = document.createElement("span");
const dummyOrigin = document.createElement("span");
dummy.className = "dummy";
dummy.style.position = "absolute";
dummy.style.left = "-10000px";

function alignHeight(element) {
  if (!element.classList.contains("hidden")) {
    element.style.height = "1px";
    element.style.height = `${element.scrollHeight + 5}px`;
  }
}

function alignStyle(element, origin) {
  element.style.boxSizing = origin.boxSizing;
  element.style.font = origin.font;
  element.style.fontSize = origin.fontSize;
  element.style.display = "inline-block";
  element.style.padding = origin.padding;
}

function adjustFontSize(element) {
  if (element.value.length < 1) {
    return +element.dataset.maxSize;
  }

  const {
    maxSize,
    maxHeight
  } = element.dataset;
  const elementStyle = getComputedStyle(element);
  alignStyle(dummy, elementStyle);
  alignStyle(dummyOrigin, elementStyle);
  dummyOrigin.style.width = elementStyle.width;
  dummyOrigin.style.height = elementStyle.height;
  dummy.innerHTML = element.value.replace("\n", "<br/>");
  document.body.appendChild(dummy);
  document.body.appendChild(dummyOrigin);

  while (dummy.scrollWidth > dummyOrigin.scrollWidth - 15) {
    // Уменьшение размера шрифта относительно ширина блока
    dummy.style.fontSize = `${parseFloat(dummy.style.fontSize) - 0.3}px`;
  }

  if (element.value.length > 1) {
    while ( // Увеличение  размер шрифта относительно ширина блока
    dummy.scrollWidth < dummyOrigin.scrollWidth - 15 && parseInt(dummy.style.fontSize, 10) < maxSize) {
      dummy.style.fontSize = `${parseFloat(dummy.style.fontSize) + 0.3}px`;
    }
  } else {
    return +element.dataset.maxSize;
  }

  if (maxHeight) {
    dummy.style.lineHeight = "1.1"; // Уменьшение размер шрифта относительно высоты блока

    do {
      dummy.style.fontSize = `${parseFloat(dummy.style.fontSize) - 0.3}px`;
    } while (parseFloat(dummy.style.fontSize) > 0 && dummy.scrollHeight > parseFloat(maxHeight));
  }

  document.body.removeChild(dummy);
  document.body.removeChild(dummyOrigin);
  const fontSize = parseInt(dummy.style.fontSize, 10);
  return fontSize > +maxSize ? maxSize : fontSize;
}

export { alignHeight, adjustFontSize };